import { FC, useCallback, useMemo, useState } from 'react'
import Image from 'next/image'
import { useDispatch, useSelector } from 'react-redux'
import { useRouter } from 'next/navigation'
import { setMaterialsSelected } from '@/redux/features/filterSlice'
import { RootState } from '@/redux/store'
import { UsefulMaterialType } from '@/redux/services/usefulMaterialTypesApi'

import s from './MaterialCategory.module.scss'
import classNames from 'classnames'

interface CardItem {
    title: string
    image_url: string
    bottomLine: string
    description?: string
    link?: string
    style?: any
    itemsStyle?: any
    category?: any
}

type Props = {
    item: UsefulMaterialType
    classItem?: string
    linked?: boolean
    type?: string
    lightTheme?: boolean
}

const MaterialsCategory: FC<Props> = ({ item, classItem, linked, type, lightTheme }) => {
    const dispatch = useDispatch()
    const router = useRouter()
    const [isHover, setIsHover] = useState(false)
    const { materialsSelected } = useSelector((state: RootState) => state.filter)
    const className = useMemo(
        () => `categories-slider__card ${type !== 'main-slider' ? 'useful-materials__categories-card' : ''} 
            ${lightTheme ? 'lightBgc' : ''}
            ${materialsSelected.find(id => id === item.id) && !linked && 'categories-slider__card_selected'} ${
            classItem && classItem
        }`,
        []
    )
    const chooseCategory = useCallback((id: number) => {
        if (linked) {
            dispatch(setMaterialsSelected([id]))
            router.push('/useful-materials')
        } else {
            if (materialsSelected.find(currentId => currentId === id)) {
                dispatch(setMaterialsSelected(materialsSelected.filter(currentId => currentId !== id)))
            } else {
                dispatch(setMaterialsSelected([...materialsSelected, id]))
            }
        }
    }, [])

    return (
        <div>
            <li
                draggable
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
                onClick={() => chooseCategory(item.id)}
                className={className}
            >
                <h3
                    className={classNames(
                        `categories-slider__title useful-materials__categories-title`,
                        lightTheme ? s.titleColor : ''
                    )}
                >
                    {item?.title ? item.title : ''}
                </h3>
                {item?.image ? (
                    <div>
                        <Image
                            width={type === 'main-slider' ? 262 : 356}
                            height={type === 'main-slider' ? 262 : 356}
                            src={`${process.env.NEXT_PUBLIC_API_ENDPOINT_IMAGES_PROD}/${item.image}`}
                            alt='animal'
                        />
                    </div>
                ) : null}
                {item?.value
                    ? item.value && (
                          <p className='categories-slider__text'>{isHover ? 'Подробнее' : item.value.toLowerCase()}</p>
                      )
                    : null}
            </li>
        </div>
    )
}

export default MaterialsCategory
